import {
  Blocks,
  Cog,
  Bot,
  Code2,
  Sun,
  HeartHandshake,
  Sparkles,
  Trophy,
  Puzzle,
} from "lucide-react";

const ICON_MAP = {
  blocks: Blocks,
  gears: Cog,
  cog: Cog,
  robot: Bot,
  code: Code2,
  sun: Sun,
  heart: HeartHandshake,
  spark: Sparkles,
  tennis: Trophy,
  puzzle: Puzzle,
};

/**
 * Renders a program logo:
 *  - if program.logo_url is set, renders an <img>
 *  - else renders the icon mapped by program.icon_type with the program's accent colour
 *  - else falls back to Sparkles + neutral palette
 *
 * Sized via the `size` prop (px). Background uses secondary_color, glyph uses accent_color.
 */
export default function ProgramLogo({ program, size = 48, rounded = "rounded-2xl" }) {
  const accent = program?.accent_color || "#0369A1";
  const secondary = program?.secondary_color || "#E0F2FE";
  if (program?.logo_url) {
    return (
      <span
        className={`inline-flex items-center justify-center overflow-hidden ${rounded} border border-white shadow-sm`}
        style={{ width: size, height: size, backgroundColor: secondary }}
        data-testid={`program-logo-${program?.slug || "unknown"}`}
      >
        <img
          src={program.logo_url}
          alt={`${program.name || "Program"} logo`}
          className="h-full w-full object-contain"
        />
      </span>
    );
  }
  const Icon = ICON_MAP[program?.icon_type] || Sparkles;
  return (
    <span
      className={`inline-flex items-center justify-center ${rounded} shrink-0`}
      style={{ width: size, height: size, backgroundColor: secondary, color: accent }}
      data-testid={`program-logo-${program?.slug || "unknown"}`}
    >
      <Icon style={{ width: size * 0.5, height: size * 0.5 }} />
    </span>
  );
}

export { ICON_MAP };
